module.exports = __webpack_public_path__ + "img/Square_MultiDark_BG.214a6546.png";